var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full relative"},[(_vm.renderer)?_c('O3D',{},[_c('MenuLayout')],1):_vm._e(),_c('MenuBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }